import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export { useStyles } from "apps/project-iq/components/WorkspaceOverview/WorkspaceOverview.styles";

export const useClientHeroStyles = makeStyles({
  heroCard: {
    border: `1px solid ${projectIqTokens.rule}`,
    borderRadius: "18px",
    overflow: "hidden",
    boxShadow: projectIqTokens.shadowSm,
    backgroundColor: projectIqTokens.card,
  },

  heroBanner: {
    background: `var(--hero-banner-bg, linear-gradient(110deg, ${projectIqTokens.navy2}, ${projectIqTokens.navy3}))`,
    padding: `${designTokens.spacing[6]} 30px`,
    color: designTokens.neutral.white,
  },

  heroKicker: {
    fontSize: "12.5px",
    fontWeight: designTokens.fontWeight.semibold,
    color: `var(--hero-kicker-text, ${projectIqTokens.sidebarFadedText})`,
  },

  heroBannerTitle: {
    fontSize: "24px",
    fontWeight: 800,
    marginTop: designTokens.spacing[1],
    letterSpacing: "-.01em",
    color: `var(--hero-title-text, ${designTokens.neutral.white})`,
  },

  heroBannerDescription: {
    margin: `${designTokens.spacing[3]} 0 0`,
    maxWidth: "640px",
    fontSize: "14px",
    lineHeight: 1.6,
    color: `var(--hero-description-text, ${projectIqTokens.sidebarItemText})`,
  },

  heroProgressSection: {
    padding: `${designTokens.spacing[5]} 30px`,
  },

  heroProgressLabelRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: designTokens.spacing[2],
  },

  heroPhaseLabel: {
    fontSize: "13.5px",
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
  },

  heroProgressText: {
    fontSize: "13px",
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
  },
});
